import React, { FC } from 'react';

import { isEqual } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { Sorted } from 'components/DataDisplay/NewTable/types';
import { useMetadataDrawerTabs } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/hooks/useMetadataDrawerTabs';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';
import { useActiveResourceActions } from 'containers/ActiveCloudResource/hooks/useActiveResourceActions';
import { MetadataTabs } from 'containers/ActiveCloudResource/types';
import { useVulnerabilityTableColumns } from 'containers/Visibility/Vulnerabilities/Components/hooks/useVulnerabilityTableColumns';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';
import { actions } from 'containers/Visibility/Vulnerabilities/slice';

interface Props {
  sortByField: Sorted;
  setSortByField(value: Sorted);
  currentRecord: Record<string, any>;
}

export const CVEHostsTable: FC<Props> = props => {
  const { sortByField, setSortByField, currentRecord } = props;
  const dispatch = useDispatch();
  const { cveHosts } = useSelector(selectVulnerabilities);

  const { tableActionModals, cveHostsColumns } = useVulnerabilityTableColumns();

  const { onOpenMetadata } = useActiveResourceContext();
  const { updateActiveResource } = useActiveResourceActions();
  const { getTabIndex } = useMetadataDrawerTabs();

  return (
    <>
      <Table
        data={cveHosts.data}
        columns={cveHostsColumns(currentRecord)}
        cursor="pointer"
        isLoading={cveHosts.isLoading}
        pagination={{
          totalCount: cveHosts.page.totalCount,
          pageInfo: cveHosts.page.info,
          onChange: pageInfo =>
            dispatch(actions.updateCveHostsPageInfo(pageInfo)),
        }}
        onRowClick={row => {
          const tabIndex = getTabIndex(
            row?.native_name,
            MetadataTabs.Vulnerabilities,
          );
          updateActiveResource({
            resourceType: row?.native_name,
            uuid: row.uuid,
            accountId: row.account,
            resourceId: row.resource_id,
            tabIndex: tabIndex,
            cloudProvider: row?.provider,
          });
          onOpenMetadata();
        }}
        onSort={sortInfo => {
          if (!isEqual(sortByField, sortInfo)) {
            setSortByField(sortInfo);
          }
        }}
        sortBy={sortByField}
      />
      {tableActionModals}
    </>
  );
};
